export const SUBSCRIPTION_STATUSES = {
  ACTIVE: 'ACTIVE',
  AWAIT_CONFIRMATION: 'AWAIT_CONFIRMATION',
  AWAIT_PAYMENT: 'AWAIT_PAYMENT',
  CANCELLED: 'CANCELLED',
  DRAFT: 'DRAFT',
  EXPIRED: 'EXPIRED',
};
